import { API_URL } from "config";
import Http from "util/https";
import { CSVThresholdCheckStock, CSVUploadCheckParam, CSVUploadThresholdResponseApi } from "../types/index";
import { stockVisibleTypeLabel } from "../constants";


/**
 * 仕入先・外部倉庫用在庫一覧Api
 * @param params 在庫一覧Apiのパラメータ
 * @returns CSVThresholdCheckStock[]
 */
export default async function getCsvThresholdConfirmCheckApi(params: CSVUploadCheckParam) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/stock/setting/csv/confirm`;
  const res = await http.post<CSVUploadThresholdResponseApi>(url, params);

  const stocks: CSVThresholdCheckStock[] = res.data.list.map(s => (
    {
      productCd: s.item_cd,
      JANCd: s.jan_cd,
      symbolThresholdList: [Number(s.threshold_max), Number(s.threshold_min)],
      stockVisibleType: stockVisibleTypeLabel[Number(s.display_mode)],
      isDiscontinued: !!Number(s.discontinued_flag),
      error: s.error ?? undefined,
    }
  ));

  console.log(res);
  console.log(stocks);
  return stocks;
}
